// extracted by mini-css-extract-plugin
export var image = "_redotech-redo-customer-portal-app-lib-portal-four-shared-components-item-detail-image";
export var small = "_redotech-redo-customer-portal-app-lib-portal-four-shared-components-item-detail-small";